<!-- Componente unificado que gerencia todos os status -->
@if (data) {
  <app-detail-status-history [data]="data"></app-detail-status-history>
}

@if (data) {
  <!-- Lista de históricos comum para todos os status -->
  @for (v of data.fileValidations; track v.id) {
    <app-detail-history-validation
      [validation]="v"
    ></app-detail-history-validation>
    <hr />
  }

  <div class="buttons-footer">
    @if (canApproveOrReject) {
      <button (click)="reject()" mat-stroked-button>
        Rejeitar arquivo
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    @if (canApproveOrReject) {
      <button (click)="approve()" mat-flat-button>
        Seguir Histórico
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (canHistoriesUpload) {
      <button (click)="navigateToReportUpload()" mat-flat-button>
        Upload Histórico de Safras
        <mat-icon>upload</mat-icon>
      </button>
    }
  </div>
}
